var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExclamation = function SvgExclamation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5997 5.09724C15.4025 6.66046 13.962 13.9502 13.4876 16.4448C13.4004 16.9098 12.9974 17.1665 12.523 17.1665H12.5073C12.0171 17.1665 11.6055 16.8941 11.5112 16.4206C11.0282 13.8875 9.58915 6.55206 9.39909 5.01167C9.16901 3.16462 10.6166 1.5415 12.483 1.5415C14.3736 1.55006 15.837 3.22595 15.5997 5.09724Z",
    fill: "#DB524D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5001 24.4582C11.348 24.4582 10.4167 23.5267 10.4167 22.3742C10.4167 21.223 11.348 20.2915 12.5001 20.2915C13.6522 20.2915 14.5834 21.223 14.5834 22.3742C14.5834 23.5267 13.6522 24.4582 12.5001 24.4582Z",
    fill: "#DB524D"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExclamation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/exclamation.f4460245bdb95b54850928ecee58a4ff.svg";